/* eslint-disable react/no-danger */
import { BpkVessel } from '@skyscanner-internal/backpack-web/bpk-component-layout';
import BpkSectionHeader from '@skyscanner-internal/backpack-web/bpk-component-section-header';

import { useMBDContext } from '../common/MBD/useMBDContext';

import type { HTMLWrapperProps } from '@skyscanner-internal/landing-pages-shared-types/types-shared/HTMLWrapperProps';

import STYLES from './HTMLWrapper.module.scss';

const HTMLWrapper = (props: HTMLWrapperProps) => {
  const { componentName, content } = props;
  const { buildMBDParam, rawComponentName } = useMBDContext();

  const uniqueId = componentName ?? '';

  const renderContent = (html: string) => (
    <div dangerouslySetInnerHTML={{ __html: html }} />
  );

  return (
    // BpkVessel: `id` and the global `html-wrapper` class are consumed externally
    <BpkVessel
      id={uniqueId}
      className="html-wrapper"
      data-tracking-element-id={rawComponentName}
      data-tracking-common-params={buildMBDParam(rawComponentName)}
    >
      {/* BpkVessel: HTMLWrapper.module.scss styles descendant `li`/`a` elements
          inside injected CMS HTML, which layout props cannot express. */}
      <BpkVessel className={STYLES.HTMLWrapper}>
        {props.title ? (
          <BpkSectionHeader title={props.title} description={props.subtitle} />
        ) : (
          ''
        )}

        {typeof content === 'string'
          ? renderContent(content)
          : [
              content.map((blurb: string) => [
                <div key={blurb}>
                  <div dangerouslySetInnerHTML={{ __html: blurb }} />
                  <br />
                </div>,
              ]),
            ]}
      </BpkVessel>
    </BpkVessel>
  );
};
export default HTMLWrapper;
